import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UnitService } from 'src/app/services/unit.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
declare const $: any;

@Component({
    selector: 'app-unit-edit',
    templateUrl: './unit-edit.component.html',
    styleUrls: ['./unit-edit.component.css']
})
export class UnitEditComponent {
    private idUnit: number = 0;

    urlPage = environment.url_page

    verificationEvidencePreviewUrl: string | null = null
    autogafaEvidencePreviewUrl: string | null = null

    constructor(
        private fb: FormBuilder,
        private utils: UtilsService,
        private spinner: NgxSpinnerService,
        private apiUnit: UnitService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.spinner.show()
        this.route.params.subscribe(params => {
            this.idUnit = params["id"]
            this.getDataUnit(params["id"])
        })
    }


    getDataUnit(id: number) {
        this.apiUnit.getId(id).subscribe((resp:any) => {
            if(!resp.type)
                resp.type=""

            if (resp.peso_bruto === null || resp.peso_bruto === undefined) resp.peso_bruto = "";
            if (resp.numero_motor === null || resp.numero_motor === undefined) resp.numero_motor = "";

            if (resp.permit_type_id === null || resp.permit_type_id === undefined) resp.permit_type_id = "";
            if (resp.vehicle_configuration_id === null || resp.vehicle_configuration_id === undefined) resp.vehicle_configuration_id = "";
            if (resp.insurer_id === null || resp.insurer_id === undefined) resp.insurer_id = "";
            if (resp.liability_insurer_id === null || resp.liability_insurer_id === undefined) resp.liability_insurer_id = "";
            if (resp.environmental_insurer_id === null || resp.environmental_insurer_id === undefined) resp.environmental_insurer_id = "";

            if (this.verificationEvidencePreviewUrl) {
                URL.revokeObjectURL(this.verificationEvidencePreviewUrl)
                this.verificationEvidencePreviewUrl = null
            }
            if (this.autogafaEvidencePreviewUrl) {
                URL.revokeObjectURL(this.autogafaEvidencePreviewUrl)
                this.autogafaEvidencePreviewUrl = null
            }

            this.formModelData = resp;
            this.spinner.hide()
        })
    }

    formModelData: any = {
        unit: null,
        plates: null,
        type: "",
        has_federal_plate: false,
        peso_bruto: "",
        numero_motor: "",
        unit_year: null,
        last_verification_date: null,
        next_verification_date: null,
        verification_evidence: null,
        autogafa_evidence: null,
        permit_type_id: "",
        permit_number: null,
        vehicle_configuration_id: "",
        insurer_id: "",
        policy_number: null,
        liability_insurer_id: "",
        liability_policy_number: null,
        environmental_insurer_id: "",
        environmental_policy_number: null,
    }

    permitTypes: any[] = []
    insurers: any[] = []
    vehicleConfigurations: any[] = []

    unitForm!: FormGroup

    ngOnInit(): void {

        this.unitForm = this.fb.group({
            type: ['', Validators.required],
            unit: ['', Validators.required],
            plates: ['', Validators.required],
            has_federal_plate: [false, Validators.required],
            peso_bruto: [''],
            numero_motor: [''],
            unit_year: ['', Validators.required],
            last_verification_date: ['', Validators.required],
            next_verification_date: ['', Validators.required],
            verification_evidence: [null],
            autogafa_evidence: [null],
            permit_type_id: ['', Validators.required],
            permit_number: ['', Validators.required],
            vehicle_configuration_id: ['', Validators.required],
            insurer_id: ['', Validators.required],
            policy_number: ['', Validators.required],
            liability_insurer_id: ['', Validators.required],
            liability_policy_number: ['', Validators.required],
            environmental_insurer_id: [''],
            environmental_policy_number: [''],
        })

        this.loadCatalogs()
    }

    loadCatalogs() {
        this.apiUnit.getPermitTypes().subscribe((resp: any) => {
            this.permitTypes = resp || []
        })
        this.apiUnit.getInsurers().subscribe((resp: any) => {
            this.insurers = resp || []
        })
        this.apiUnit.getVehicleConfigurations().subscribe((resp: any) => {
            this.vehicleConfigurations = resp || []
        })
    }

    onFileChange(event: any, key: string) {
        const file = event?.target?.files?.[0]
        if (file) {
            ;(this.formModelData as any)[key] = file

            if (key === 'verification_evidence') {
                this.formModelData.verification_evidence_path = null

                if (this.verificationEvidencePreviewUrl) {
                    URL.revokeObjectURL(this.verificationEvidencePreviewUrl)
                }
                this.verificationEvidencePreviewUrl = URL.createObjectURL(file)
            }
            if (key === 'autogafa_evidence') {
                this.formModelData.autogafa_evidence_path = null

                if (this.autogafaEvidencePreviewUrl) {
                    URL.revokeObjectURL(this.autogafaEvidencePreviewUrl)
                }
                this.autogafaEvidencePreviewUrl = URL.createObjectURL(file)
            }

            this.unitForm.patchValue({ [key]: file })
            this.unitForm.get(key)?.markAsDirty()
        }
    }

    goToChecklist() {
        this.router.navigateByUrl('/unit/checklist', { state: { data: this.formModelData } });
    }

    updateUnit() {
        if (this.unitForm.valid) {
            this.spinner.show()
            const payload: any = { ...this.formModelData }
            payload.has_federal_plate = payload.has_federal_plate ? '1' : '0'

            this.apiUnit.updateUnitForm(payload, this.idUnit).subscribe((resp: any) => {
                this.spinner.hide()
                this.utils.alertSwal({ title: "Exitoso", text: resp.msg, icon: "success" })

                if (this.verificationEvidencePreviewUrl) {
                    URL.revokeObjectURL(this.verificationEvidencePreviewUrl)
                    this.verificationEvidencePreviewUrl = null
                }
                if (this.autogafaEvidencePreviewUrl) {
                    URL.revokeObjectURL(this.autogafaEvidencePreviewUrl)
                    this.autogafaEvidencePreviewUrl = null
                }

                this.router.navigateByUrl('/unit/list')
            }, (error) => {
                this.spinner.hide()
                this.utils.alertSwal({ title: "Error!", text: "Se ha presentado un error al actualizar la unidad", icon: "error" })
            })
        } else {

            this.utils.alertSwal({ title: "Advertencia", text: "Verifique que la información se encuentre completa.", icon: "warning" })
        }
    }

    get registerFormControl() {
        return this.unitForm.controls;
    }
}
